<template>
  <div class="distributor-box platform-order">
    <Tabs v-if="showTab" v-model="pageParams.orderTabStatus" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in orderTabTypeList" :disabled="item.disabled" :label="item.title" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter-box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1006261')">
              <morePlatforms
                v-if="pendingTalg"
                ref="morePlatforms"
                :showNumericalValue="showNumericalValue"
                :pendingData="pendingData"
                :platformList="platformList"
                :dataSource="true"
                :defaultPlatformNumber="defaultPlatformNumber"
                :defaultPlatform="defaultPlatform"
                @selectPlatform="selectPlatform">
              </morePlatforms>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol"
            v-show="['null','4','5','6'].includes(pageParams.orderTabStatus)">
            <Form-item :label="$t('key1006262')" prop="ymsOrderStatus">
              <Select v-model.trim="pageParams.ymsOrderStatus" @on-change="(val) => getList(true)">
                <Option v-for="(item, index) in ymsOrderStatusList" :key="index" :value="item.value">
                  {{ item.name }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1006263')" prop="ymsPlatformAccountIds">
              <Select v-model="pageParams.ymsPlatformAccountIds" filterable clearable allow-create @on-create="handleCreate">
                <Option
                  v-for="(item, index) in shopList"
                  :key="index"
                  :label="item.code"
                  :value="item.ymsPlatformAccountId">
                  {{ item.code }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol"
            v-if="pageParams.platformId !== 'temu' && moreFilter">
            <Form-item :label="$t('key1006188')" prop="isRefunded">
              <Select v-model="pageParams.isRefunded">
                <Option value="null">{{ $t('key1000110') }}</Option>
                <Option value="1">{{ $t('key1000392') }}</Option>
                <Option value="0">{{ $t('key1000393') }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1004338')" class="date_picker_style">
              <Date-picker
                type="datetimerange"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="payTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="['null','1'].includes(pageParams.orderTabStatus)">
            <Form-item :label="$t('key1006264')" :label-width="160" prop="abnormalStatus">
              <Select v-model="pageParams.abnormalStatus">
                <Option v-for="item in platformOrderAbnormalityList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="['null','1'].includes(pageParams.orderTabStatus)">
            <Form-item :label="$t('key1006265')" :label-width="160" prop="ymsAbnormalStatus">
              <Select v-model="pageParams.ymsAbnormalStatus">
                <Option v-for="item in ymsAbnormalStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol"
            v-if="pageParams.platformId === 'temu'">
            <Form-item :label="$t('key1006190')" prop="executeDespatchStatus">
              <Select v-model="pageParams.executeDespatchStatus">
                <Option v-for="item in executeShipmentStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="orderTypePlatformIds.includes(pageParams.platformId)">
            <FormItem :label="$t('key1004503')" prop="orderTypeTag">
              <Select v-model="pageParams.orderTypeTag" filterable>
                <Option v-for="item in orderTypesList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter"
              inputType="textarea"
              :selectStyle="{width: '100px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002820')" prop="searchValue">
              <Input v-model.trim="pageParams.searchValue" :placeholder="searchValueText"/>
            </Form-item>
          </Col>
          <Col style="min-width: 170px;" push="1">
            <Button @click="reset(true)" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
        <Row type="flex" justify="end" :gutter="gutterItem">
          <Col style="text-align: right;">
            <Button size="small" @click="toggleMoreFilter">{{ moreFilterMes }}
              <Icon :type="moreFilterIcon" size="small"></Icon>
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation-box flex align-items-center justify-content-between">
      <div>
        <!--Temu平台订单-->
        <template v-if="['temu'].includes(pageParams.platformId)">
          <!--          <Button class="mr15" type="primary" v-if="getPermission('ymsPlatformOrder_createPlatformOrder')"
            @click="$router.push('/addTemuOrder')">创建订单</Button>-->
          <Button class="mr15" type="primary" v-if="getPermission('ymsPlatformOrder_implementShipment')
            && ['4'].includes(pageParams.orderTabStatus)" @click="executeShipmentBtn">{{ $t('key1006241') }}</Button>
        </template>
        <!--速卖通全托管平台订单-->
        <template v-else-if="pageParams.platformId === 'aliexpress'">
          <Button class="mr15" type="primary" @click="receivingOrdersBtn('all')">{{ $t('key1006268') }}</Button>
        </template>
        <!--其他平台订单-->
        <template v-else>
          <Button v-if="['4'].includes(pageParams.orderTabStatus)" class="mr15" type="primary" @click="standardShipmentBtn('all')">{{ $t('key1006203') }}</Button>
          <Button v-if="['1'].includes(pageParams.orderTabStatus)" class="mr15" type="primary" @click="placeOrderBtn('all')">{{ $t('key1001936') }}</Button>
        </template>
        <!--导出数据-->
        <Dropdown transfer class="mr15" @on-click="changeExportBtn" v-if="getPermission('ymsPlatformOrder_excelYmsPlatformOrderExport')">
          <Button type="primary">
            <span>{{ $t('key1003082') }}</span>
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
            <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <!--批量标记非YMS订单-->
        <Button v-if="['1'].includes(pageParams.orderTabStatus)" @click="markNonYmsOrdersBtn('all')"
          class="mr15" type="primary">{{ $t('key1006267') + configCharacters() + $t('key1001887') }}</Button>
      </div>
      <div class="flex align-items-center">
        <Button class="mr15" v-if="getPermission('ymsPlatformOrder_saveMarkedShipmentSetting')"
          @click="$refs['standardShippingSettings'].initStandardShippingSettingsData()">{{ $t('key1006269') }}</Button>
        <Button @click="$refs['customColumns'].initCustomColumnsData()">{{ $t('key1000977') }}</Button>
      </div>
    </div>
    <!--列表区域-->
    <div class="table-box mt10">
      <Table
        ref="selection"
        border
        max-height="520"
        :span-method="handleSpan"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="tableChange">
      </Table>
    </div>
    <!--分页区域-->
    <Page
      :transfer="true"
      v-if="!tableLoading"
      :total="total"
      class="distributor-page-box"
      @on-change="changePage"
      show-total
      :page-size="pageParams.pageSize"
      show-elevator
      :current.sync="pageParams.pageNum"
      show-sizer
      @on-page-size-change="changePageSize"
      placement="top"
      :page-size-opts="pageArray">
    </Page>
    <!--订单操作日志弹窗-->
    <commonLogModal
      ref="commonLog"
      logMode="DISTRIBUTOR"
      modalWidth="1200"
      :showWarehouse="true"
      :showPage="true">
    </commonLogModal>
    <!--平台订单详情-->
    <platformOrderDetail ref="platformOrderDetail" @updatePlatformList="pageParamsStatus = true"></platformOrderDetail>
    <!--下单异常、批量接单异常提示弹窗-->
    <Modal v-model="orderPromptModal" :transfer="false" class-name="tips_style" :title="abnormalTitle">
      <div class="tips_center" v-for="(item,index) in orderPromptList" :key="index">
        <h4 class="title">{{ item.orderNumber }}</h4>
        <p class="txt">{{ item.errorMsg }}</p>
      </div>
      <template #footer>
        <div style="text-align: center;">
          <Button @click="orderPromptModal = false">{{ $t('key1000248') }}</Button>
        </div>
      </template>
    </Modal>
    <!--到仓详情弹窗-->
    <arrivalDetailsModal ref="arrivalDetails"></arrivalDetailsModal>
    <!--手工单--货品单-执行发货弹窗(需要上传标签)-->
    <temuExecuteShipmentModal ref="temuExecuteShipment" @updateData="pageParamsStatus = true"></temuExecuteShipmentModal>
    <!--平台单、手工单--样品单-执行发货弹窗(不需要上传标签)-->
    <sampleOrderModal ref="sampleOrder" @updateData="pageParamsStatus = true"></sampleOrderModal>
    <!--自定义列组件-->
    <customColumnsDrawer
      ref="customColumns"
      customColumnsKey="platformOrderColumns"
      :originalColumns="originalColumns"
      :defaultSelectKeyList="defaultSelectKeyList"
      @customColumnsData="customColumnsData">
    </customColumnsDrawer>
    <!--添加商品弹窗-->
    <addCommonProductModal
      ref="addCommonProduct"
      :apiUrl="apiUrl"
      :customStyle="true"
      :showOptionsBtn="false"
      systemType="distributor"
      :distributorShowFieldKeyList="['options', 'goodsInfo','myInventory', 'supplierAvailableNumber', 'ymsAvailableNumber', 'suggestPrice', 'weight', 'length', 'status']"
      @updateData="updateData">
    </addCommonProductModal>
    <!--修改物流商信息弹窗-->
    <editLogisticsModal ref="editLogistics" @updateData="updateData"></editLogisticsModal>
    <!--导出订单字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1006266')"
      paramKeyColums="ymsPlatformOrderExportColumns"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--标发货设置弹窗-->
    <standardShippingSettingsModal :platformList="platformList" ref="standardShippingSettings"></standardShippingSettingsModal>
    <!--取消订单弹窗-->
    <cancelPlatformOrderModal ref="cancelPlatformOrder" @updateData="updateData"></cancelPlatformOrderModal>
    <!--录入IOSS弹窗-->
    <uploadIossModal ref="uploadIoss" @updateData="updateData"></uploadIossModal>
    <!--订单轨迹弹窗-->
    <orderTrajectoryModal ref="orderTrajectory" form="platformOrder"></orderTrajectoryModal>
    <!--去付款弹窗-->
    <goMakeThePaymentModal ref="goMakeThePayment" @updateData="updateData"></goMakeThePaymentModal>
    <!--修改物流地址弹窗-->
    <modifyLogisticsAddressModal ref="modifyLogisticsAddress" @updateData="updateData"></modifyLogisticsAddressModal>
    <!--temu_choice平台，Temu后台发货仓库弹窗-->
    <matchWarehouseModal ref="matchWarehouse" @updateData="updateData"></matchWarehouseModal>
    <!--商品发货仓弹窗-->
    <shippingWarehouseModal ref="shippingWarehouse" @updateData="updateData"></shippingWarehouseModal>
    <!--待配置定制内容弹窗-->
    <configureCustomizedContentModal ref="configureCustomizedContent" @updateData="updateData"></configureCustomizedContentModal>
    <!--关联合规信息弹窗-->
    <relatedComplianceInfoModal ref="relatedComplianceInfo" @updateData="updateData"></relatedComplianceInfoModal>
    <!--订单提交弹窗-->
    <orderSubmissionModal ref="orderSubmission" @updateOrderData="updateData"></orderSubmissionModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import commonLogModal from "@/components/common/commonLogModal";
import platformOrderDetail from '@/views/distributor/components/orderManage/platformOrderDetail';
import {CANNOTCANCELPLATFORMORDERSLIST, YMSORDERSTATUSLIST} from '@/utils/enum';
import api from '@/api/';
import morePlatforms from "@/components/common/morePlatforms";
import arrivalDetailsModal from "@/views/distributor/components/orderManage/arrivalDetailsModal";
import temuExecuteShipmentModal from "@/views/distributor/components/orderManage/temuExecuteShipmentModal";
import sampleOrderModal from "@/views/distributor/components/orderManage/sampleOrderModal.vue";
import customColumnsDrawer from "@/components/common/customColumnsDrawer";
import addCommonProductModal from "@/components/common/addCommonProductModal.vue";
import editLogisticsModal from "@/views/distributor/components/orderManage/components/editLogisticsModal.vue";
import exportFieldsModal from "@/components/common/exportFieldsModal.vue";
import standardShippingSettingsModal from "@/views/distributor/components/orderManage/standardShippingSettingsModal";
import cancelPlatformOrderModal from "@/views/distributor/components/orderManage/components/cancelPlatformOrderModal.vue";
import uploadIossModal from "@/views/distributor/components/orderManage/components/uploadIossModal";
import orderTrajectoryModal from "@/views/distributor/components/orderManage/components/orderTrajectoryModal";
import {
  jumpToTheCourierInquiry, pageJump, handleImagesData, setConfigCharacters, getEnumName, getEnumList, commonLocalStorage,
  isAlibabaDistributor, getAllMatchingLogisticsData, EventBus, getEnabledPlatforms, getDataSetBatchList
} from "@/utils/common";
import goMakeThePaymentModal from "@/views/distributor/components/orderManage/components/goMakeThePaymentModal.vue";
import modifyLogisticsAddressModal from "@/views/distributor/components/orderManage/components/modifyLogisticsAddressModal.vue";
import dropDownFilter from "@/components/common/dropDownFilter.vue";
import matchWarehouseModal from "@/views/distributor/components/orderManage/components/matchWarehouseModal.vue";
import shippingWarehouseModal from "@/views/distributor/components/orderManage/shippingWarehouseModal.vue";
import configureCustomizedContentModal from "@/components/common/configureCustomizedContentModal.vue";
import relatedComplianceInfoModal from "@/views/distributor/components/orderManage/relatedComplianceInfoModal.vue";
import orderSubmissionModal from "@/components/common/orderSubmissionModal.vue";

export default {
  name: 'platformOrder',
  mixins: [Mixin],
  components: {
    orderSubmissionModal,
    shippingWarehouseModal,
    dropDownFilter,
    exportFieldsModal,
    editLogisticsModal,
    addCommonProductModal,
    commonLogModal,
    platformOrderDetail,
    morePlatforms,
    arrivalDetailsModal,
    temuExecuteShipmentModal,
    sampleOrderModal,
    customColumnsDrawer,
    standardShippingSettingsModal,
    cancelPlatformOrderModal,
    uploadIossModal,
    orderTrajectoryModal,
    goMakeThePaymentModal,
    modifyLogisticsAddressModal,
    matchWarehouseModal,
    configureCustomizedContentModal,
    relatedComplianceInfoModal
  },
  data() {
    let v = this;
    return {
      apiUrl: api.post_ymsDistributorProductInfo_queryYmsProductGoods,
      pageParamsStatus: false,
      pageParams: {
        orderTabStatus: '1', // 待处理
        orderTypeTag: 'null', // 订单类型: 1:TEMU样品(TEMU_S) 2:TEMU货品(TEMU_P) 3:全部
        isRefunded: 'null', // 0:未退款 1:有退款
        executeDespatchStatus: null, // 执行发货状态 0 全部 1待集货 2待执行发货 3已执行发货
        paymentEndTime: null,
        paymentStartTime: null,
        platformId: 'shopify',
        ymsPlatformAccountIds: 'null',
        searchValue: '',
        platformOrderNos: '',
        platformOrderIds: '',
        status: 'null',
        ymsOrderStatus: 'null',
        abnormalStatus: 'null',
        ymsAbnormalStatus: 'null',
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      payTime: [],
      tableColumns: [],
      originalColumns: [
        {
          type: 'selection',
          className: 'selection_styles_box',
          key: 'select',
          width: 60
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006184'),
          minWidth: 300,
          align: 'left',
          key: 'platformOrderInfo',
          className: 'platformOrderInfo_styles_box',
          render(h, params) {
            let platformId = params.row.platformId;
            let orderTag = params.row.orderTag;
            // 订单编号
            let platformOrderNo = [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004534')),
              orderTag === 'TIKTOK_CBT' ? h('span', {class: 'TiktokCBT_box'}, 'Tiktok-CBT') : '',
              h('Alink', {
                props: {
                  linkName: params.row.platformOrderNo,
                  AlinkShow: v.getPermission('get_ymsPlatformOrder'),
                  textAlign: 'left',
                  AlinkClass: 'reset_alink',
                  resetIconClass: 'reset_icon'
                },
                on: {
                  AlinkBtn: () => {
                    v.$refs['platformOrderDetail'].orderNumber = params.row.platformOrderNo;
                    v.$refs['platformOrderDetail'].getPlatformOrderDetailsInfo(params.row.ymsPlatformOrderId, v.originalPlatformList);
                  }
                }
              })
            ];
            // PO单号
            let platformOrderId = params.row.platformOrderId;
            // 下单时间
            let platformSalesTime = v.$uDate.dealTime(params.row.platformSalesTime, 'fulltime');
            // 付款时间
            let payTime = v.$uDate.dealTime(params.row.payTime, 'fulltime');
            // 店铺名称
            let storeCode = params.row.storeCode;
            // 站点
            let siteName = '';
            let platformItemSiteId = params.row.platformItemSiteId;
            if (v.platformSiteData.length > 0) {
              v.platformSiteData.map((item) => {
                if (item.siteId === platformItemSiteId) {
                  siteName = item.region;
                }
              });
            }
            return h('div', {class: 'flex flex-direction'}, [
              h('p', {class: 'mt4 mb1 flex flex-wrap'}, [platformOrderNo]),
              platformId === 'walmart' ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006185') + platformOrderId) : '',
              h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004337') + platformSalesTime),
              h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004338') + payTime),
              h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002774') + storeCode),
              siteName ? h('p', {class: 'mt2 mb2'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000665') + siteName) : '',
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006186'),
          minWidth: 280,
          align: 'left',
          key: 'platformOrderItemInfo',
          render(h, params) {
            let list = [];
            let ymsPlatformOrderTransactions = params.row.ymsPlatformOrderTransactions || [];
            if (ymsPlatformOrderTransactions.length > 0) {
              let num = ymsPlatformOrderTransactions.length - 3;
              ymsPlatformOrderTransactions.map((item, index) => {
                let primaryImage = null;
                let imgUrl = '';
                // 是否已经匹配商品
                let talg = !!item.businessId;
                if (talg) {
                  primaryImage = item.primaryImage;
                  imgUrl = v.getThumbnailImage(primaryImage, '/thumb/', '70x70', true) || v.failPlaceholder;
                } else {
                  primaryImage = item.pictureUrl; // 原始平台图片
                  imgUrl = v.setImgPath(primaryImage);
                }
                if (index <= 2) {
                  list.push(
                    h('div',
                      {
                        class: 'ymsPackageGoodBox',
                        on: {
                          click() {
                            v.$refs['platformOrderDetail'].orderNumber = params.row.platformOrderNo;
                            v.$refs['platformOrderDetail'].getPlatformOrderDetailsInfo(params.row.ymsPlatformOrderId, v.originalPlatformList);
                          }
                        }
                      },
                      [
                        primaryImage ? h('img', {
                          attrs: {src: imgUrl},
                          class: 'ymsPackageGoodImg',
                          on: {
                            error($event) {
                              v.setErrorImg($event)
                            }
                          }
                        }) : h('span', {class: 'pl3 pt3'}, item.platformItemSku),
                        h('span', {class: 'ymsPackageGoodQuantity'}, 'x' + item.quantity),
                        num > 0 && index === 2 ? h('div', {class: 'maskBox font-size-18 font-weight-bold color-white'}, '+' + num) : ''
                      ]));
                }
              });
            }
            return h('div', {class: 'flex flex-align-center'}, list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004472'),
          minWidth: 200,
          align: 'left',
          key: 'platformOrderStatus',
          render(h, params) {
            let platformId = params.row.platformId;
            let platformOrderStatusName = '-';
            // 订单状态
            if (params.row.platformOrderStatus === '02') {
              platformOrderStatusName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006187');
            } else {
              let platformOrderStatus = params.row.platformOrderStatus ? Number(params.row.platformOrderStatus) : null;
              v.thirhPartyPlatformOrderStatusList.map((item) => {
                if (item.value === platformOrderStatus) {
                  platformOrderStatusName = item.name;
                }
              });
            }
            // 是否有退款
            let isRefunded = params.row.isRefunded === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393');
            // 是否标发货
            let despatchedTime = params.row.despatchedTime ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393');
            // 订单类型
            let orderType = params.row.orderType;
            let orderTypeName = getEnumName(v.enumData, 'YmsPlatformOrderOrderTypeDistributorEnum', orderType);
            // 执行发货状态
            let executeDespatchStatusName = '';
            let status = params.row.status;
            let executeDespatchStatus = params.row.executeDespatchStatus;
            if (![1, 2, 3].includes(status)) {
              v.executeShipmentStatusList.map((item) => {
                if (item.value === executeDespatchStatus) {
                  executeDespatchStatusName = item.title;
                }
              });
            }
            // 下单数量
            let orderTotalQuantity = params.row.orderTotalQuantity;
            //  到仓数量
            let orderTotalAllottedQuantity = params.row.orderTotalAllottedQuantity;
            return h('div', {class: 'flex flex-direction'}, [
              h('p', {class: 'mt4 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004602') + platformOrderStatusName),
              h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006188') + isRefunded),
              platformId !== 'temu' ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006189') + despatchedTime) : '',
              ['temu', 'aliexpress'].includes(platformId) ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000930') + orderTypeName) : '',
              platformId === 'temu' ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006190') + executeDespatchStatusName) : '',
              platformId === 'temu' ? h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006191') + orderTotalQuantity) : '',
              platformId === 'temu' ? h('p', {
                class: v.getPermission('get_ymsPlatformOrder') ? 'distributorThemeColor cursor mt2 mb2' : 'mt2 mb2',
                on: {
                  click() {
                    if (v.getPermission('get_ymsPlatformOrder')) {
                      v.$refs['arrivalDetails'].initArrivalDetailsData(params.row.ymsPlatformOrderId);
                    }
                  }
                },
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004583') + orderTotalAllottedQuantity) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004471'),
          minWidth: 140,
          align: 'left',
          key: 'platformOrderAmount',
          render(h, params) {
            let totalPriceCurrency = params.row.totalPriceCurrency || '';
            let totalPrice = v.formatCurrency(params.row.totalPrice);
            return h('span', totalPrice + ' ' + totalPriceCurrency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006148'),
          key: 'destinationBuyerInfo',
          align: 'left',
          minWidth: 260,
          render(h, params) {
            // 目的地
            let buyerCountryCode = params.row.buyerCountryCode;
            // 买家ID
            let destination = params.row.buyerAccountId;
            // 买家姓名
            let buyerName = params.row.buyerName;
            // 买家备注
            let buyerNotes = v.checkContentOverflow(h, params.row.buyerNotes, 150, 1)
            return h('div', {class: 'flex flex-direction'}, [
              h('p', {class: 'mt4 mb1 ellipsis_1', attrs: {title: buyerCountryCode}}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006149') + buyerCountryCode),
              h('p', {class: 'mt2 mb1 ellipsis_1', attrs: {title: destination}}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006150') + destination),
              h('p', {class: 'mt2 mb1 ellipsis_1', attrs: {title: buyerName}}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006110') + buyerName),
              h('p', {class: 'mt2 mb2 flex'}, [
                h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006192')),
                h('div', {style: 'flex: 1'}, [buyerNotes])
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006193'),
          minWidth: 140,
          key: 'platformOrderAbnormality',
          align: 'left',
          render(h, params) {
            let abnormalStatus = params.row.abnormalStatus;
            let text = '';
            v.platformOrderAbnormalityList.map((item) => {
              if (item.value === abnormalStatus) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006194'),
          minWidth: 260,
          align: 'left',
          key: 'ymsOrderInfo',
          render(h, params) {
            let performanceParty = params.row.performanceParty; // 履约方：YMS  ALIGJ
            let thirdOrderId = '';
            let ymsPackageInfo = params.row.ymsPackageInfo;
            if (ymsPackageInfo) {
              thirdOrderId = ymsPackageInfo.thirdOrderId || '';
            }
            // 订单编号
            let packageCode = params.row.packageCode || '';
            // 下单时间
            let ymsCreateTime = params.row.ymsCreateTime || '';
            // 发货物流
            let shippingCarrierName = params.row.shippingCarrierName || '';
            let orderNumber = performanceParty === 'YMS' ? packageCode : thirdOrderId;
            return h('div', [
              performanceParty === 'ALIGJ' ? h('p', {class: 'alibabaOrders_item'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006195')) : '',
              h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004534') + orderNumber),
              h('p', {class: 'mt2 mb1'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004337') + ymsCreateTime),
              h('p', {class: 'mt2 mb2'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006196') + shippingCarrierName)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006197'),
          minWidth: 280,
          key: 'ymsOrderItemInfo',
          align: 'left',
          render(h, params) {
            let list = [];
            let ymsPackageGoods = params.row.ymsPackageGoods || [];
            if (ymsPackageGoods.length > 0) {
              let num = ymsPackageGoods.length - 3;
              ymsPackageGoods.map((item, index) => {
                if (index <= 2) {
                  list.push(h('div',
                    {
                      class: 'ymsPackageGoodBox',
                      on: {
                        click() {
                          v.$refs['platformOrderDetail'].orderNumber = params.row.platformOrderNo;
                          v.$refs['platformOrderDetail'].getPlatformOrderDetailsInfo(params.row.ymsPlatformOrderId, v.originalPlatformList);
                        }
                      }
                    },
                    [
                      h('img', {
                        attrs: {src: v.getThumbnailImage(item.primaryImage, '/thumb/', '70x70', true) || v.failPlaceholder},
                        class: 'ymsPackageGoodImg',
                        on: {
                          error($event) {
                            v.setErrorImg($event)
                          }
                        }
                      }),
                      h('span', {class: 'ymsPackageGoodQuantity'}, 'x' + item.quantity),
                      num > 0 && index === 2 ? h('div', {class: 'maskBox font-size-18 font-weight-bold color-white'}, '+' + num) : ''
                    ]));
                }
              });
            }
            return h('div', {class: 'flex flex-align-center'}, list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006198'),
          minWidth: 230,
          key: 'ymsOrderStatus',
          align: 'left',
          render(h, params) {
            let title = '';
            let time = '';
            let expressageNo = '';
            let expressageCode = '';
            let trackingNumber = '';
            let performanceParty = params.row.performanceParty; // 履约方：YMS  ALIGJ
            let ymsPackageInfo = params.row.ymsPackageInfo;
            let ymsPackageId = params.row.ymsPackageId;
            let timeFormat = v.countdowns[ymsPackageId]?.leftTime || '';
            if (ymsPackageInfo) {
              let status = ymsPackageInfo.status;
              let payStatus = ymsPackageInfo.payStatus; // 1 待付款、2 已付款
              let ymsOrderStatus = ymsPackageInfo.ymsOrderStatus;
              let transportTypeTalg = ymsPackageInfo.transportType === 2; // 上门揽收
              let offlinePaymentStatus = ymsPackageInfo.offlinePaymentStatus;
              let text = '';
              YMSORDERSTATUSLIST.map((item) => {
                if (item.value === ymsOrderStatus) {
                  title = item.name;
                  time = v.$uDate.dealTime(ymsPackageInfo[item.key], 'fulltime');
                  // 已装箱
                  if (item.key === 'supperBoxedTime') {
                    expressageNo = ymsPackageInfo.expressageNo;
                    expressageCode = ymsPackageInfo.expressageCode;
                    trackingNumber = ymsPackageInfo.trackingNumber;
                  }
                }
              });
              if (performanceParty === 'YMS') {
                if (ymsOrderStatus === 12) {
                  text = title
                } else {
                  if (status === 2) {
                    text = getEnumName(v.enumData, 'YmsPlatformOrderShippingPayStatusDistributorEnum', payStatus, 'number');
                  } else {
                    text = title;
                  }
                }
                return h('div', [
                  h('p',
                    {
                      class: 'mt4 mb1 distributorThemeColor cursor',
                      on: {
                        click() {
                          v.$refs['orderTrajectory'].initOrderTrajectoryData(ymsPackageInfo);
                        }
                      }
                    },
                    text),
                  timeFormat && status !== 8 && payStatus === 1 && ![2].includes(offlinePaymentStatus) ?
                    h('p', {class: 'mt4 mb1 distributorThemeColor'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006151') + timeFormat) : '',
                  expressageNo && !transportTypeTalg ? h('p', {class: 'flex align-items-center'}, [
                    h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004362')),
                    h('span', {
                      class: 'distributorThemeColor',
                      on: {
                        click() {
                          jumpToTheCourierInquiry(expressageCode, expressageNo, trackingNumber)
                        }
                      }
                    }, expressageNo),
                  ]) : '',
                  h('p', {class: 'mt2 mb2'}, time)
                ]);
              } else {
                let text = '';
                if (payStatus) {
                  text = getEnumName(v.enumData, 'YmsPlatformOrderShippingPayStatusDistributorEnum', payStatus, 'number');
                } else {
                  v.cloudsalesorderstatusList.map((item) => {
                    if (![7, 8].includes(item.value)) {
                      text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002920');
                    } else {
                      text = item.title;
                    }
                  })
                }
                return h('span', text);
              }
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006199'),
          minWidth: 150,
          align: 'left',
          key: 'ymsOrderAmount',
          render(h, params) {
            let performanceParty = params.row.performanceParty; // 履约方：YMS  ALIGJ
            if (performanceParty === 'ALIGJ') {
              let ymsPackageInfo = params.row.ymsPackageInfo;
              if (ymsPackageInfo) {
                let ymsOrderAmount = ymsPackageInfo.totalPrice;
                let currencyState = ymsOrderAmount !== '-' ? v.currencyState : ''
                return h('span', ymsOrderAmount + ' ' + currencyState);
              } else {
                return h('span', '-');
              }
            } else {
              let ymsOrderAmount = params.row.ymsOrderAmount || '-';
              let currencyState = ymsOrderAmount !== '-' ? v.currencyState : ''
              return h('span', ymsOrderAmount + ' ' + currencyState);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006200'),
          key: 'ymsOrderAbnormality',
          align: 'left',
          minWidth: 200,
          render: (h, params) => {
            let text = '';
            let ymsPackageInfo = params.row.ymsPackageInfo;
            if (ymsPackageInfo) {
              let abnormalStatus = ymsPackageInfo?.abnormalStatus;
              let carrierStatus = ymsPackageInfo?.carrierStatus;
              let trackingNumber = ymsPackageInfo?.trackingNumber;
              let distributionFailed = [3, 6, 9, 12, 16]; // 下发失败 [3,6,9,12,16]
              let carrierErrorMsg = ymsPackageInfo.carrierErrorMsg || ''; // 下发物流失败原因
              let packageGoodsStatus = ymsPackageInfo.packageGoodsStatus; // 订单货品状态 1、补货中 2、部分补货中 3 部分缺货 商品已停售,4、缺货,商品已停售
              let txt = getEnumName(v.enumData, 'YmsPackageInfoPackageGoodsStatusCoreEnum', packageGoodsStatus, 'number');
              let estimateArrivalOfGoodsTime = ymsPackageInfo.estimateArrivalOfGoodsTime ? v.$uDate.dealTime(ymsPackageInfo.estimateArrivalOfGoodsTime) : null;
              let expectedDeliveryTimeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006118') + estimateArrivalOfGoodsTime + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006119');
              let errorMsgTalg = null;
              if (distributionFailed.includes(carrierStatus)) {
                errorMsgTalg = true;
                text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006161');
              }
              if (!trackingNumber) {
                let list = getEnumList(v.enumData, 'YmsCarrierErrorMsgCoreEnum');
                list.map((item) => {
                  if (item.value === carrierErrorMsg) {
                    errorMsgTalg = false;
                    text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004447')
                  }
                  if (carrierErrorMsg === 'A999') {
                    errorMsgTalg = true;
                    text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006161');
                  }
                });
              }
              let ymsPackageGoods = ymsPackageInfo.ymsPackageGoods || [];
              let totalOutOfStockQuantity = ymsPackageGoods.reduce((accumulator, currentItem) => accumulator + currentItem.outOfStockQuantity, 0);
              return h('div', [
                // 下发物流失败
                h('div', [
                  text ? h('span', text) : '',
                  errorMsgTalg && carrierErrorMsg ? h('Tooltip', {
                    props: {
                      transfer: true,
                      maxWidth: 400,
                      content: carrierErrorMsg
                    },
                    style: {
                      marginLeft: '5px'
                    }
                  }, [
                    h('Icon', {
                      props: {
                        type: 'md-information-circle',
                        size: 16
                      },
                      style: {
                        cursor: 'pointer',
                        color: 'red'
                      }
                    })
                  ]) : ''
                ]),
                // 缺货
                abnormalStatus === 2 ? h('div', {class: 'crimsonRedColor'}, [
                  h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000536')),
                  txt ? h('div', [
                    h('p', {class: 'crimsonRedColor'}, txt),
                    estimateArrivalOfGoodsTime ? h('div', {class: 'flex'}, [
                      h('span', {class: 'crimsonRedColor'}, expectedDeliveryTimeText),
                      h('Tooltip', {
                        props: {
                          transfer: true,
                          maxWidth: 400,
                          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006120')
                        },
                        style: {
                          marginLeft: '5px'
                        }
                      }, [
                        h('Icon', {
                          props: {
                            type: 'md-information-circle',
                            size: 16
                          },
                          style: {
                            cursor: 'pointer',
                            color: 'red'
                          }
                        })
                      ]),
                    ]) : '',
                    totalOutOfStockQuantity > 0 ? h('p', `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004360')}${totalOutOfStockQuantity}`) : ''
                  ]) : ''
                ]) : ''
              ]);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'left',
          key: 'options',
          className: 'options_styles_box',
          width: 110,
          render(h, params) {
            let platformId = params.row.platformId;
            let updateAddress = params.row.updateAddress;
            let performanceParty = params.row.performanceParty; // 履约方：YMS  ALIGJ
            let isHandProcessingInvalid = params.row.isHandProcessingInvalid; // 0 需要标记处理  1 不需要标记处理
            let isInvalid = params.row.isInvalid; // 0:未作废 1:已作废
            // 三方平台订单状态 0:核查中、1:待发货、2:已发货、21:部分发货、3:已签收、31:部分签收、4:取消、41:部分取消
            let platformOrderStatusTalg = v.pageParams.orderTabStatus !== '6';
            let ymsPlatformOrderId = params.row.ymsPlatformOrderId;
            let status = params.row.status; // YMS平台订单状态1.待匹配商品2.匹配物流失败3.下单失败4.已下单5.已发货
            let isYmsOrder = params.row.isYmsOrder;
            let abnormalStatus = params.row.abnormalStatus;
            let ymsAbnormalStatus = params.row.ymsAbnormalStatus;
            let orderTabStatus = v.pageParams.orderTabStatus !== '7';
            let packageGoodsStatus = params.row.packageGoodsStatus || [];  // [1], 订单货品状态 1、补货中 2、部分补货中 3、缺货 4 部分缺货 5、商品已停售
            let packageGoodsStatusTalg = false;
            if (packageGoodsStatus.length > 0) {
              packageGoodsStatusTalg = packageGoodsStatus.some((item) => {
                return [1, 2].includes(item)
              })
            }
            // 判断当前平台中是否已经产生订单,且过滤掉已取消的订单且订单是未支付状态， payStatus:1待付款，2已付款
            let ymsPlatformOrderPackageRelateds = params.row.ymsPlatformOrderPackageRelateds || [];
            let isThereAnOrder = ymsPlatformOrderPackageRelateds.some((item) => {
              return item.ymsPackageInfo && item.ymsPackageInfo.status !== 8 && item.ymsPackageInfo.payStatus !== 2
            })
            // 线下支付翻译状态：1:待付款 2:确认中 3:被退回 4:已完成 5:已取消  6 付款中
            let isOfflinePaymentStatus = ymsPlatformOrderPackageRelateds.some((item) => {
              return item.ymsPackageInfo && item.ymsPackageInfo.status !== 8 && item.ymsPackageInfo.offlinePaymentStatus !== 2
            })

            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001936'),
                    show: platformOrderStatusTalg && isYmsOrder === 2 && [3, 21].includes(status) && orderTabStatus,
                    clickFn: () => {
                      v.operateObj = params.row;
                      v.placeOrderBtn('single');
                    }
                  },
                  {
                    text: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006176')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001887')}`, // 是否YMS订单{1：否 2：是}
                    show: platformOrderStatusTalg && isYmsOrder === 2 && [0, 1, 2, 3].includes(status) && orderTabStatus,
                    clickFn: () => {
                      v.markNonYmsOrdersBtn('single', ymsPlatformOrderId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006201'), // 1.待匹配商品 2.匹配物流失败 3.下单失败
                    show: platformOrderStatusTalg && isYmsOrder === 2 && status === 1 && orderTabStatus,
                    clickFn: () => {
                      // 需求调整---因为列表中匹配商品会随机匹配，不知道匹配到那个,所以调整匹配商品的时候跳转到详情中进行匹配
                      /*let ymsPlatformOrderTransactionId = null;
                      let ymsPlatformOrderTransactions = params.row.ymsPlatformOrderTransactions || [];
                      if (ymsPlatformOrderTransactions.length > 0) {
                        ymsPlatformOrderTransactions.map((item) => {
                          if (item.ymsPlatformOrderId === ymsPlatformOrderId) {
                            ymsPlatformOrderTransactionId = item.ymsPlatformOrderTransactionId;
                          }
                        })
                      }
                      if (ymsPlatformOrderTransactionId) {
                        v.$refs['addCommonProduct'].matchingGoodsType = 'manual';
                        v.$refs['addCommonProduct'].ymsPlatformOrderTransactionId = ymsPlatformOrderTransactionId;
                        v.$refs['addCommonProduct'].initFun();
                      }*/
                      v.$refs['platformOrderDetail'].orderNumber = params.row.platformOrderNo;
                      v.$refs['platformOrderDetail'].getPlatformOrderDetailsInfo(params.row.ymsPlatformOrderId, v.originalPlatformList);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006005'),
                    show: platformOrderStatusTalg && isYmsOrder === 2 && status === 2 && orderTabStatus,
                    clickFn: () => {
                      v.$refs['editLogistics'].initEditLogisticsData(params.row, 'listType');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006202'),
                    show: platformOrderStatusTalg && isYmsOrder === 1,
                    clickFn: () => {
                      v.processOrderBtn(ymsPlatformOrderId)
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006203'),
                    show: platformOrderStatusTalg && v.pageParams.platformId !== 'temu' && abnormalStatus === 4 && orderTabStatus,
                    clickFn: () => {
                      v.standardShipmentBtn('single', params.row)
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004533'),
                    show: platformOrderStatusTalg && ymsAbnormalStatus === 1 && orderTabStatus,
                    clickFn: () => {
                      v.distributionLogisticsBtn(params.row.ymsPackageId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006204'),
                    show: platformOrderStatusTalg && packageGoodsStatusTalg,
                    clickFn: () => {
                      v.confirmWaitingBtn(ymsPlatformOrderId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004290'),
                    show: v.getPermission('ymsPlatformOrder_invalid') && performanceParty !== 'ALIGJ' &&
                      (platformOrderStatusTalg && v.cancelOrderTalg(params.row)) && !CANNOTCANCELPLATFORMORDERSLIST.includes(platformId),
                    clickFn: () => {
                      v.cancelOrderBtn(params.row)
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006205'),
                    show: platformOrderStatusTalg && v.pageParams.platformId === 'aliexpress' && abnormalStatus === 0, // 待接单状态且是速卖通全托管平台订单
                    clickFn: () => {
                      v.receivingOrdersBtn('single', ymsPlatformOrderId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000288'),
                    show: v.getPermission('ymsLog_query'),
                    clickFn: () => {
                      v.$refs['commonLog'].initCommonLogData(ymsPlatformOrderId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006088'),
                    show: platformOrderStatusTalg && v.manualMarkingTalg(params.row),
                    clickFn: () => {
                      v.manualMarkingBtn(ymsPlatformOrderId)
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005998'),
                    show: abnormalStatus === 5,
                    clickFn: () => {
                      v.$refs['uploadIoss'].initUploadIossData(params.row, 'platformOrder')
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006012'),
                    show: performanceParty === 'ALIGJ' && isHandProcessingInvalid === 0,
                    clickFn: () => {
                      v.markProcessedBtn(ymsPlatformOrderId)
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006082'),
                    show: performanceParty === 'ALIGJ' && isInvalid === 0 && isThereAnOrder && isOfflinePaymentStatus,
                    clickFn: () => {
                      v.$refs['goMakeThePayment'].initGoMakeThePaymentData(params.row)
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000609'),
                    show: performanceParty === 'YMS' && isInvalid === 0 && isThereAnOrder && isOfflinePaymentStatus,
                    clickFn: () => {
                      v.ymsPaymentBtn(ymsPlatformOrderId, params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006206'),
                    show: performanceParty === 'ALIGJ' && isInvalid === 0 && updateAddress === 1,
                    clickFn: () => {
                      v.$refs['modifyLogisticsAddress'].initModifyLogisticsAddressData(params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000269'),
                    show: performanceParty === 'ALIGJ' && isInvalid === 0 && updateAddress === 1,
                    clickFn: () => {
                      v.ignoreBtn(ymsPlatformOrderId)
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006207'),
                    show: abnormalStatus === 9,
                    clickFn: () => {
                      v.$refs['matchWarehouse'].initMatchWarehouseData(params.row, 'platformOrder');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005940'),
                    show: abnormalStatus === 11,
                    clickFn: () => {
                      v.$refs['shippingWarehouse'].initShippingWarehouseData(params.row, 'platformOrder')
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000691'),
                    show: abnormalStatus === 12,
                    clickFn: () => {
                      v.$refs['configureCustomizedContent'].initConfigureCustomizedContentData('platformOrder', params.row)
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006208'),
                    show: abnormalStatus === 10 && v.orderComplianceLabelVerificationTalg,
                    clickFn: () => {
                      v.$refs['relatedComplianceInfo'].initRelatedComplianceInfoData(params.row);
                    }
                  },
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      shopList: [],
      selectTableData: [],
      orderPromptList: [],
      orderPromptModal: false,
      abnormalTitle: '',
      defaultPlatform: null,
      orderTabTypeList: [ // 4.已下单 5.已发货 6.已取消 7.非YMS订单
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'), disabled: false},
        {
          value: '1',
          disabled: false,
          title: (h) => {
            return h('div', [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006166')),
              h('Badge', {
                props: {
                  count: v.reviewedTotal,
                  overflowCount: 999
                }
              })
            ])
          }
        },
        {value: '4', disabled: false, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006209')},
        {value: '5', disabled: false, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006210')},
        {value: '6', disabled: false, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006211')},
        {value: '7', disabled: false, title: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006176')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001887')}`},
      ],
      processingStatusList: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'), value: 'null'},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006212'), value: 1},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006213'), value: 2},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001907'), value: 3}
      ],
      operateObj: {},
      pendingTalg: false,
      pendingData: [],
      reviewedTotal: 0,
      platformList: [],
      exportType: null,
      customFieldExportData: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004467'),
          titleKey: 'platformOrderInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'platformOrderNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001737')},
            {paramKey: 'platformOrderId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006214')},
            {paramKey: 'platformId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006215')},
            {paramKey: 'ymsPlatformAccountName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001794')},
            {paramKey: 'ymsAbnormalStatus', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004110')}`},
            {paramKey: 'despatchStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006216')},
            {paramKey: 'orderSkuAndQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006217')},
            {paramKey: 'totalPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004471')},
            {paramKey: 'platformItemSiteId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003502')},
            {paramKey: 'isRefunded', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006218')},
            {paramKey: 'abnormalStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006219')},
            {paramKey: 'buyerCountryCode', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004276')},
            {paramKey: 'platformSalesTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004474')},
            {paramKey: 'payTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004475')},
            {paramKey: 'buyerAccountId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006220')},
            {paramKey: 'buyerName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006221')},
            {paramKey: 'description', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006222')},
            {paramKey: 'orderType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004464')},
          ]
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006194'),
          titleKey: 'orderInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'packageCode', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006223')},
            {paramKey: 'status', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006198')},
            {paramKey: 'ymsSku', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006224')},
            {paramKey: 'productQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003656')},
            {paramKey: 'amount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004452')},
            {paramKey: 'totalAmount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004453')},
            {paramKey: 'handlePrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006225')},
            {paramKey: 'prepayHandlePrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006165')},
            {paramKey: 'totalShippingFeeIncome', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006226')},
            {paramKey: 'ymsLogisServiceName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005379')},
            {paramKey: 'thirdPartyNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004440')},
            {paramKey: 'trackingNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004458')},
            {paramKey: 'virtualTrackingNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004459')},
            {paramKey: 'packageCreatedTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006227')},
            {paramKey: 'shipedTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006228')},
            {paramKey: 'ymsLogisServiceEfficiency', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006229')},
            {paramKey: 'ymsOrderType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004464')},
          ]
        }
      ],
      defaultSelectKeyList: ['platformOrderInfo', 'select', 'options'], // 自定义列--默认选中的key，且不参与自定义列排序
      setColumnsList: [],
      originalPageParams: {},
      originalPlatformList: [],
      orderTypePlatformIds: ['temu', 'aliexpress'], // 当前只有Temu、速卖通全托管区分了平台订单类型
      orderTypesList: [],
      platformSiteData: [],
      ymsFieldkeyList: ['ymsOrderInfo', 'ymsOrderItemInfo', 'ymsOrderStatus', 'ymsOrderAmount', 'ymsOrderAbnormality'], // yms级别的列表字段key
      ownLogisticsList: [],
      ymsOrderStatusList: YMSORDERSTATUSLIST.filter((item) => {
        return item.value !== 11
      }),
      showTab: false,
      showNumericalValue: true,
      defaultSelectValue: 1,
      matchingLogisticsData: [],
      countdownsTime: {},
      countdowns: {},
      enumData: []
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 订单合规标签校验配置项是否开启
    orderComplianceLabelVerificationTalg() {
      const saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(saasConfigurationItems?.orderComplianceLabelVerificationSaas) === 1;
    },
    // 平台订单异常状态
    platformOrderAbnormalityList() {
      const ENUM_KEY = 'YmsPlatformOrderAbnormalStatusDistributorEnum';
      // 先取对应枚举
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      // 非阿里分销商，过滤掉阿里专属状态
      if (!isAlibabaDistributor()) {
        list = list.filter(item => ![6, 7, 8].includes(item.value));
      }
      if (!this.orderComplianceLabelVerificationTalg) {
        list = list.filter(item => item.value !== 10);
      }
      list.unshift({
        value: 'null',
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      return list;
    },
    // 执行发货状态
    executeShipmentStatusList() {
      const ENUM_KEY = 'YmsPlatformOrderExecuteDespatchStatusDistributorEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    },
    // 分销订单异常状态
    ymsAbnormalStatusList() {
      const ENUM_KEY = 'YmsPlatformOrderYmsAbnormalStatusDistributorEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        value: 'null',
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      return list;
    },
    // 云卖订单状态
    cloudsalesorderstatusList() {
      const ENUM_KEY = 'YmsPlatformOrderShippingStatusDistributorEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    },
    // 三方平台订单状态
    thirhPartyPlatformOrderStatusList() {
      const ENUM_KEY = 'YmsPlatformOrderPlatformOrderStatusDistributorEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number')
    },
    searchValueText() {
      let platformId = this.pageParams.platformId;
      let text = '';
      switch (platformId) {
        case 'walmart':
          text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006230');
          break;
        default:
          text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006231');
      }
      return text;
    },
    dropDownInputList() {
      let platformId = this.pageParams.platformId;
      let list = [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004470'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006232'), parameterKey: 'platformOrderNos'}
      ];
      switch (platformId) {
        case 'walmart':
          list.push({title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006214'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006233'), parameterKey: 'platformOrderIds'})
          break;
      }
      return list;
    },
    customFieldExportList() {
      let platformId = this.pageParams.platformId;
      let newData = JSON.parse(JSON.stringify(this.customFieldExportData));
      if (platformId === 'walmart') {
        return newData
      } else {
        return newData.map((item) => {
          if (item.titleKey === 'platformOrderInfoColums') {
            item.checkBoxList = item.checkBoxList.filter((ele) => {
              return ele.paramKey !== 'platformOrderId';
            });
          }
          return item;
        });
      }
    },
    filterKeyList() {
      return this.dropDownInputList.map((item) => {
        return item.parameterKey
      });
    },
    defaultPlatformNumber() {
      return this.showNumericalValue ? 11 : 13;
    },
  },
  mounted() {
    EventBus.$on('updatePlatformOrder', (data) => {
      let obj = JSON.parse(data) || '';
      this.defaultConditionQuery(obj);
    });
  },
  created() {
    let v = this;
    v.initWebSocket();
    v.$store.commit('updatePendingCount', Date.now());
    let obj = localStorage.getItem('platformOrderQuery') ? JSON.parse(localStorage.getItem('platformOrderQuery')) : '';
    if (['null', '5', '6'].includes(v.pageParams.orderTabStatus)) {
      v.setDefaultTimerParams('three_months');
    }
    if (v.$route.params.platformId) {
      v.getSpecifyPlatform();
    }
    // 消息中心跳转过来的
    else {
      v.defaultConditionQuery(obj)
    }
  },
  methods: {
    // 触发带着默认条件查询
    defaultConditionQuery(obj) {
      let v = this;
      if (obj) {
        v.pageParams.platformId = obj.platformId;
        v.pageParams.platformOrderNos = obj.platformOrderNos;
        v.initFun(obj.platformId);
        setTimeout(() => {
          v.$store.commit('updateDistributorMenu', false);
          localStorage.removeItem('platformOrderQuery');
        }, 2000);
      } else {
        v.initFun();
      }
    },
    // 初始化接口数据
    initFun(platformId) {
      let v = this;
      (async () => {
        // 枚举的数据集
        let enumKeyList = [
          'YmsPlatformOrderOrderTypeDistributorEnum',
          'YmsPlatformOrderAbnormalStatusDistributorEnum',
          'YmsPlatformOrderExecuteDespatchStatusDistributorEnum',
          'YmsPlatformOrderYmsAbnormalStatusDistributorEnum',
          'YmsPlatformOrderShippingStatusDistributorEnum',
          'YmsPlatformOrderPlatformOrderStatusDistributorEnum',
          'YmsPlatformOrderShippingPayStatusDistributorEnum',
          'YmsPackageInfoPackageGoodsStatusCoreEnum',
          'YmsCarrierErrorMsgCoreEnum'
        ];
        v.enumData = await getDataSetBatchList(enumKeyList);
        // 获取所有站点的数据
        v.platformSiteData = [];
        await getEnabledPlatforms().then((data) => {
          data.map((item) => {
            v.platformSiteData.push(...item.sites)
          });
        });
        // 获取平台待处理的总数
        await v.getPlatformNameData(platformId).then(() => {
          v.originalPageParams = JSON.parse(JSON.stringify(v.pageParams));
          v.getProductsNum();
          v.getPlatformStoreData('');
          v.search();
        });
      })();
    },
    // 初始化选中指定的平台
    getSpecifyPlatform() {
      let v = this;
      v.$nextTick(() => {
        v.getPlatformNameData().then(() => {
          v.getProductsNum().then(() => {
            v.defaultPlatform = platformId || v.$route.params.platformId;
            let platformGroup = v.$refs['morePlatforms'].platformGroup;
            if (localStorage.getItem('platformIdList')) {
              platformGroup = JSON.parse(localStorage.getItem('platformIdList'));
            }
            if (platformGroup.length > 0) {
              let index = platformGroup.findIndex((item) => {
                return item.platformId === v.$route.params.platformId;
              });
              v.$refs['morePlatforms'].getPlatformData(v.$route.params.platformId, index, platformGroup)
            }
          });
        });
      })
    },
    // 获取对应平台下店铺的数据
    getPlatformStoreData(value) {
      let v = this;
      let query = {
        code: value,
        platformIds: [v.pageParams.platformId]
      };
      let codeList = [];
      if (v.shopList.length > 0) {
        v.shopList.map((item) => {
          codeList.push(item.code);
        });
      }
      if (!codeList.includes(value)) {
        v.shopList = [];
        v.axios.post(api.post_ymsPlatformAccount_queryYmsPlatformAccountList, query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              let talg = data.some((item) => {
                return item.ymsPlatformAccountId === 'null'
              });
              if (!talg) {
                data.unshift({
                  code: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'),
                  ymsPlatformAccountId: 'null'
                });
              }
              v.shopList = data;
            }
          }
        });
      }
    },
    // 搜索店铺
    handleCreate(value) {
      this.getPlatformStoreData(value);
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getProductsNum(true);
      this.getList();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      params.orderTabStatus = Number(v.pageParams.orderTabStatus);
      let nullKeyList = ['status', 'isRefunded', 'ymsOrderStatus', 'abnormalStatus', 'ymsAbnormalStatus', 'orderTypeTag'];
      nullKeyList.map((key) => {
        params[key] = params[key] === 'null' ? null : v.pageParams[key];
      });
      if (v.pageParams.ymsPlatformAccountIds) {
        if (v.pageParams.ymsPlatformAccountIds === 'null') {
          params.ymsPlatformAccountIds = [];
        } else {
          params.ymsPlatformAccountIds = [v.pageParams.ymsPlatformAccountIds];
        }
      }
      if (v.orderTypePlatformIds.includes(v.pageParams.platformId)) {
        params.orderTypeTag = v.pageParams.orderTypeTag;
      } else {
        params.orderTypeTag = null;
      }
      if (v.pageParams.platformId === 'temu') {
        params.executeDespatchStatus = v.pageParams.executeDespatchStatus;
      } else {
        params.executeDespatchStatus = null;
      }

      function handleData(key) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }

      for (let key in params) {
        if (params.platformId === 'walmart') {
          handleData(key);
        } else {
          handleData(key);
          params.platformOrderIds = [];
        }
      }
      return params;
    },

    // 获取子账号授权店铺过滤的平台
    getPlatformNameData(platformId) {
      let v = this;
      return new Promise((resolve) => {
        v.axios.get(api.get_ymsPlatformOrder_queryPlatformName + '?platformType=sales').then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              if (platformId) {
                v.defaultPlatform = platformId;
                v.pageParams.platformId = platformId;
              } else {
                v.defaultPlatform = data[0].platformId;
                v.pageParams.platformId = data[0].platformId;
              }
              let newData = handleImagesData(data);
              v.originalPlatformList = JSON.parse(JSON.stringify(newData));
              v.platformList = JSON.parse(JSON.stringify(newData));
              resolve(true);
            }
          }
        });
      });
    },
    // 获取列表数据
    getList(value) {
      let v = this;
      v.optionBtnWidth = [];
      v.selectTableData = [];
      v.tableData = [];
      v.total = 0;
      v.handleColumns();
      v.$store.commit('updatePendingCount', Date.now());
      if (value) {
        this.pageParams.pageNum = 1;
      }
      if (v.getPermission('ymsPlatformOrder_query')) {
        v.tableLoading = true;
        let ymsPlatformAccountIds = [];
        v.axios.post(api.post_ymsPlatformOrder_query, v.handleParameter()).then(response => {
          v.$refs['selection'].selectAll(false);
          if (response.data.code === 0) {
            let data = response.data.datas;
            let list = data.list || [];
            if (list.length > 0) {
              list.map((item, index) => {
                ymsPlatformAccountIds.push(item.ymsPlatformAccountId);
              });
              ymsPlatformAccountIds = v.uniqueFunc(ymsPlatformAccountIds)
              v.getStoreCode(list, ymsPlatformAccountIds);
            } else {
              v.tableLoading = false;
            }
            v.total = data.total;
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 根据ymsPlatformAccountId获取对应店铺的code
    getStoreCode(data, ymsPlatformAccountIds) {
      let v = this;
      let businessIds = [];
      let ymsProductGoodsIds = [];
      let ymsPlatformOrderTransactions = [];
      if (ymsPlatformAccountIds.length > 0) {
        v.optionBtnWidth = [];
        let ymsWarehouseIds = [];
        data.map((item) => {
          let list = item.ymsPlatformOrderTransactions || [];
          let ymsPlatformOrderPackageRelateds = item.ymsPlatformOrderPackageRelateds || [];
          if (list.length > 0) {
            ymsPlatformOrderTransactions.push(...list);
          }
          // 获取YMS订单商品id
          if (ymsPlatformOrderPackageRelateds.length > 0) {
            ymsWarehouseIds = ymsPlatformOrderPackageRelateds.map(item => item.ymsPackageInfo && item.ymsPackageInfo.ymsWarehouseId).filter(Boolean);
            ymsPlatformOrderPackageRelateds.map((ele) => {
              if (ele.ymsPackageInfo) {
                let ymsPackageGoods = ele.ymsPackageInfo.ymsPackageGoods || [];
                if (ymsPackageGoods.length > 0) {
                  ymsPackageGoods.map((talg) => {
                    ymsProductGoodsIds.push(talg.ymsProductGoodsId)
                  })
                }
              }
            })
          }
        });
        // 获取平台订单已经匹配的YMS订单id
        if (ymsPlatformOrderTransactions.length > 0) {
          ymsPlatformOrderTransactions.map((ele) => {
            ele.ymsProductGoodsId = ele.businessId;
            if (ele.businessId) {
              businessIds.push(ele.businessId)
            }
          });
        }
        let list = [...ymsProductGoodsIds, ...businessIds];
        let newList = v.uniqueFunc(list);
        getAllMatchingLogisticsData({warehouseIds: ymsWarehouseIds}).then((logisticsData) => {
          v.matchingLogisticsData = logisticsData;
          if (newList.length > 0) {
            v.getProductInfoByIds(newList, [], false, true).then((newData) => {
              if (newData && newData.length > 0) {
                data.map((ele) => {
                  let ymsPlatformOrderTransactions = ele.ymsPlatformOrderTransactions || [];
                  let ymsPlatformOrderPackageRelateds = ele.ymsPlatformOrderPackageRelateds || [];
                  newData.map((talg) => {
                    let ymsProductGoodsList = talg.ymsProductGoodsList || [];
                    if (ymsProductGoodsList.length > 0) {
                      ymsProductGoodsList.map((k) => {
                        // 平台订单匹配YMS订单的图片
                        if (ymsPlatformOrderTransactions.length > 0) {
                          ymsPlatformOrderTransactions.map((j) => {
                            if (j.businessId === k.ymsProductGoodsId) {
                              j.primaryImage = k.primaryImage || talg.primaryImage;
                            }
                          })
                        }
                        // 获取YMS订单商品图片
                        if (ymsPlatformOrderPackageRelateds.length > 0) {
                          ymsPlatformOrderPackageRelateds.map((p) => {
                            if (p.ymsPackageInfo) {
                              let ymsPackageGoods = p.ymsPackageInfo.ymsPackageGoods || [];
                              if (ymsPackageGoods.length > 0) {
                                ymsPackageGoods.map((t) => {
                                  if (t.ymsProductGoodsId === k.ymsProductGoodsId) {
                                    t.primaryImage = k.primaryImage || talg.primaryImage;
                                  }
                                })
                              }
                            }
                          })
                        }
                      })
                    }
                  });
                });
                handleFun(data);
              }
            });
          } else {
            handleFun(data);
          }
        });

        function handleFun(list) {
          v.axios.post(api.post_ymsPlatformAccount_queryYmsPlatformAccountByIds, ymsPlatformAccountIds).then(response => {
            if (response.data.code === 0) {
              let datas = response.data.datas;
              if (datas) {
                datas.map((item) => {
                  list.map((ele) => {
                    if (ele.ymsPlatformAccountId === item.ymsPlatformAccountId) {
                      ele.storeCode = item.code;
                    }
                  });
                });
                v.handleData(list);
              }
            } else {
              v.tableLoading = false;
            }
          });
        }
      } else {
        v.handleData(data);
      }
    },
    // 处理列表数据按照YMS订单维度展示
    handleData(data) {
      let v = this;
      if (data && data.length > 0) {
        let newList = [];
        let noOrdersList = [];
        let list = [];

        // 累加费用方法
        function sumNumByType(arr) {
          const result = {};
          for (let i = 0; i < arr.length; i++) {
            const obj = arr[i];
            const type = obj.type;
            const amount = obj.amount || 0;

            if (type in result) {
              result[type] += amount;
            } else {
              result[type] = amount;
            }
          }
          return result;
        }

        data.map((item) => {
          item.platformOrderCreationTime = item.createdTime;
          let ymsPlatformOrderPackageRelateds = item.ymsPlatformOrderPackageRelateds || [];
          let ymsPlatformOrderPackageRelatedsList = ymsPlatformOrderPackageRelateds.filter((ele) => ele.ymsPackageInfo && Object.keys(ele.ymsPackageInfo).length > 0);
          if (ymsPlatformOrderPackageRelatedsList.length > 0) {
            ymsPlatformOrderPackageRelatedsList.map((ele) => {
              ele.ymsOrderStatus = '-';
              ele.ymsCreateTime = '-';
              ele.carrierErrorMsg = '';
              ele.shippingCarrierName = '';
              let ymsPackageInfo = ele.ymsPackageInfo;
              let ymsPackageCosts = ele.ymsPackageCosts || [];
              if (ymsPackageCosts.length > 0) {
                // 费用类型 1 货品费用  2 包裹处理费 3退费 4物流费 6快递费 7清关费用
                let obj = sumNumByType(ymsPackageCosts);
                let num = 0;
                if (Object.keys(obj).length > 0) {
                  for (const key in obj) {
                    if (obj.hasOwnProperty(key)) {
                      num += obj[key];
                    }
                  }
                }
                ele.ymsOrderAmount = v.formatCurrency(num) || 0;
              } else {
                ele.ymsOrderAmount = '-';
              }
              if (ymsPackageInfo) {
                let {ymsLogisServiceId, carrierId, shippingMethodId, ymsWarehouseId} = ymsPackageInfo;
                ymsPackageInfo.trajectoryStatusList = [];
                if (ymsPackageInfo.status !== 8) {
                  ele.carrierErrorMsg = ymsPackageInfo.carrierErrorMsg;
                }
                ele.ymsPackageGoods = ymsPackageInfo.ymsPackageGoods || [];
                ele.ymsOrderStatus = ymsPackageInfo.status;
                ele.ymsCreateTime = ymsPackageInfo.createdTime ? v.$uDate.dealTime(ymsPackageInfo.createdTime, 'fulltime') : '-';
                ele.expectedDeliveryTime = ymsPackageInfo.estimateArrivalOfGoodsTime ? v.$uDate.dealTime(ymsPackageInfo.estimateArrivalOfGoodsTime) : '';
                ele.packageGoodsStatus = ymsPackageInfo.packageGoodsStatus;
                v.matchingLogisticsData.forEach(talg => {
                  if (talg.ymsWarehouseId !== ymsWarehouseId) return;
                  talg.logisticsData.forEach(k => {
                    k.list.forEach(j => {
                      // YMS物流
                      if (ymsLogisServiceId) {
                        if (j.ymsLogisServiceId === ymsLogisServiceId) {
                          ele.shippingCarrierName = j.name;
                        }
                      }
                      // 自有物流、供应商物流
                      else {
                        const match = (j.carrierId === carrierId && j.shippingMethodId === shippingMethodId) ||
                          (j.coreCarrierId === carrierId && j.coreShippingMethodId === shippingMethodId);
                        if (match) {
                          ele.shippingCarrierName = j.name;
                        }
                      }
                    });
                  });
                });
                // 处理轨迹状态数据
                let ymsOrderStatus = ymsPackageInfo.ymsOrderStatus;
                let sort;
                YMSORDERSTATUSLIST.map((k) => {
                  if (k.value === ymsOrderStatus && k.value !== 'null') {
                    sort = k.sort;
                  }
                });
                let keyList = YMSORDERSTATUSLIST.filter((k) => {
                  return k.sort <= sort;
                });
                if (keyList.length > 0) {
                  keyList.map((val) => {
                    for (let key in ymsPackageInfo) {
                      if (val.key === key) {
                        if (ymsPackageInfo[key]) {
                          if (key === 'allottedTime') {
                            if (ymsPackageInfo.packagePattern === 1) {
                              ymsPackageInfo.allottedTime = ymsPackageInfo.allottedTime;
                            } else if (ymsPackageInfo.packagePattern === 2) {
                              ymsPackageInfo.allottedTime = ymsPackageInfo.allottedTime;
                            }
                          }
                          ymsPackageInfo.trajectoryStatusList.push(val)
                        }
                      }
                    }
                  });
                }
              }
              let obj = Object.assign({}, ele, item);
              newList.push(obj);
            })
          } else {
            noOrdersList.push(item);
          }
        });
        let arr = [...newList, ...noOrdersList];
        // 根据平台订单创建时间降序排序
        arr = arr.sort((a, b) => new Date(b.platformOrderCreationTime) - new Date(a.platformOrderCreationTime));
        if (arr.length > 0) {
          let newData = v.handerGrouping(arr, function (item) {
            return [item.ymsPlatformOrderId];
          }, 'ymsPlatformOrderId');
          newData.map((item) => {
            if (item.data.length > 0) {
              item.data.map((ele, index) => {
                let length = item.data.length;
                ele['length'] = length;
                ele['currentTalg'] = (length > 1 && index === 0);
                list.push(ele)
              })
            }
          });
          if (list.length > 0) {
            list.map((item, idx) => {
              item['tableLength'] = list.length;
              if (item.currentTalg) {
                item['currentIndex'] = idx;
              }
              v.countdownsTime[item.ymsPackageId] = {
                payLeftTime: item.ymsPackageInfo?.payLeftTime || null
              }
              // 启动倒计时
              if (item.ymsPackageInfo?.payLeftTime) {
                v.handleCountDown(item.ymsPackageId);
              }
            });
            v.tableData = list;
            v.updateTableDom('selection', 3000);
          }
        }
      }
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      let v = this;
      let columnList = [];
      if (v.tableColumns.length > 0) {
        v.tableColumns.map((item, index) => {
          if (!v.ymsFieldkeyList.includes(item.key)) {
            columnList.push(index);
          }
        })
      }
      if (columnList.includes(columnIndex)) {
        if (row.length > 1) {
          if (rowIndex === row.currentIndex) {
            return [row.length, 1]
          } else {
            for (let i = 0; i <= row.tableLength; i++) {
              if (rowIndex === i) {
                return [0, 0]
              }
            }
          }
        }
      }
    },
    // 处理列表Columns字段
    handleColumns(data) {
      let v = this;
      v.optionBtnWidth = [];
      let hideKeyColumns = [];
      // 非YMS订单时，屏蔽yms级别的字段
      if (v.pageParams.orderTabStatus === '7') {
        hideKeyColumns.push(...v.ymsFieldkeyList);
      }
      let sortKeyList = data || v.setColumnsList;
      let list = v.handleCustomColumnsSort(sortKeyList, hideKeyColumns, v.originalColumns, v.defaultSelectKeyList);
      if (list.length > 0) {
        v.tableColumns = list;
      } else {
        hideKeyColumns = v.uniqueFunc(hideKeyColumns);
        v.tableColumns = v.originalColumns.filter((item) => {
          return !hideKeyColumns.includes(item.key)
        });
      }
      v.updateTableDom('selection', 3000);
    },
    // 重置数据
    reset(val) {
      let v = this;
      v.changeInput(1);
      v.$refs['pageParams'].resetFields();
      if (v.pageParams.platformId === 'temu') {
        v.pageParams.orderTypeTag = 3;
        v.pageParams.executeDespatchStatus = 0;
      } else {
        v.pageParams.executeDespatchStatus = null;
        v.pageParams.orderTypeTag = null;
      }
      v.payTime = [];
      v.resetDate();
      v.selectTableData = [];
      if (['null', '5', '6'].includes(v.pageParams.orderTabStatus)) {
        v.setDefaultTimerParams('three_months');
      }
      if (val) {
        v.getList();
      }
    },
    // 重置付款时间
    resetDate() {
      this.pageParams.paymentStartTime = null;
      this.pageParams.paymentEndTime = null;
    },
    // 获取日期返回值
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.paymentStartTime = null;
          v.pageParams.paymentEndTime = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.payTime = v.defaultTimePeriod(value, false);
          v.pageParams.paymentStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.paymentEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 选取平台
    selectPlatform(platformId) {
      let v = this;
      let {orderTabStatus, ...obj} = JSON.parse(JSON.stringify(v.originalPageParams));
      for (let key in obj) {
        v.pageParams[key] = obj[key];
      }
      v.payTime = [];
      v.resetDate();
      v.selectTableData = [];
      v.pageParams.platformId = platformId;
      v.getPlatformStoreData('');
      v.tableData = [];
      if (v.pageParams.platformId === 'temu') {
        v.pageParams.orderTypeTag = 3;
        v.pageParams.executeDespatchStatus = 0;
      } else {
        v.pageParams.executeDespatchStatus = null;
        v.pageParams.orderTypeTag = null;
      }
      if (['null', '5', '6'].includes(v.pageParams.orderTabStatus)) {
        v.setDefaultTimerParams('three_months');
      }
      setTimeout(() => {
        v.pageParams.pageNum = 1;
        v.pageParams.ymsPlatformAccountIds = 'null';
        v.pageParamsStatus = true;
      }, 300);
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = data;
    },
    // 标发货
    standardShipmentBtn(type, row) {
      let v = this;
      let obj = {
        traceId: null,
        platformOrderShipmentsBos: []
      };
      if (type === 'all') {
        if (v.selectTableData.length > 0) {
          v.selectTableData.map((item) => {
            obj.platformOrderShipmentsBos.push({
              ymsPlatformOrderId: item.ymsPlatformOrderId,
              packageCode: null, // 更改结构  前端不传
              carrierCode: null// 更改结构 YMS-6055 前端不传
            });
          });
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006234'));
          return false;
        }
      } else {
        obj.platformOrderShipmentsBos = [{
          ymsPlatformOrderId: row.ymsPlatformOrderId,
          packageCode: null, // 更改结构  前端不传
          carrierCode: null// 更改结构 YMS-6055 前端不传
        }];
      }
      v.axios.put(api.put_ymsPlatformOrder_markedShipment, obj, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.selectTableData = [];
          let success = response.data.datas.success;
          if (success) {
            if (type === 'all') {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006235'));
            } else {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              v.getProductsNum();
              v.pageParamsStatus = true;
            }
          } else {
            let text = response.data.datas.markDeliveryResultBo.message;
            v.$Message.error(text);
          }
        }
      });
    },
    // 下发物流
    distributionLogisticsBtn(ymsPackageId) {
      let v = this;
      let ymsPackageIds = [ymsPackageId];
      v.axios.post(api.post_ymsPlatformOrder_syncUploadLogistics, ymsPackageIds, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          v.getProductsNum();
          v.pageParamsStatus = true;
        }
      });
    },
    // 下单
    placeOrderBtn(type) {
      let v = this;
      v.abnormalTitle = '';
      v.orderPromptList = [];
      v.orderPromptModal = false;
      let ymsPlatformOrderIds = [];
      // 批量操作
      if (type === 'all') {
        if (v.selectTableData.length > 0) {
          v.selectTableData.map((item) => {
            ymsPlatformOrderIds.push(item.ymsPlatformOrderId);
          });
          placeOrderFun(ymsPlatformOrderIds, type)
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006236'));
          return false;
        }
      } else {
        placeOrderFun([v.operateObj.ymsPlatformOrderId], type)
      }

      function placeOrderFun(ymsPlatformOrderIds, type) {
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006237'),
          content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006177')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006178')}`,
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000543'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            v.axios.put(api.put_ymsPlatformOrder_batchPlaceOrder, ymsPlatformOrderIds,
              {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                let data = response.data.datas;
                if (data.length > 0) {
                  data.map((item) => {
                    if (type === 'all') {
                      v.selectTableData.map((ele) => {
                        if (item.ymsPlatformOrderId === ele.ymsPlatformOrderId) {
                          item.orderNumber = ele.platformOrderNo;
                        }
                      });
                    } else {
                      if (item.ymsPlatformOrderId === v.operateObj.ymsPlatformOrderId) {
                        item.orderNumber = v.operateObj.platformOrderNo;
                      }
                    }
                  });
                  v.orderPromptList = data;
                  v.getProductsNum();
                  v.abnormalTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006238');
                  v.orderPromptModal = true;
                  v.operateObj = {};
                } else {
                  v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
                }
                v.pageParamsStatus = true;
              }
            });
          },
          onCancel: () => {
          }
        });
      }
    },
    // Temu订单--执行发货
    executeShipmentBtn() {
      let v = this;
      if (v.selectTableData.length > 0) {
        // 不同店铺的订单不可同时执行发货
        let targetStoreCode = v.selectTableData[0].storeCode;
        let storeTalg = v.selectTableData.every((item) => {
          return item.storeCode === targetStoreCode;
        });
        if (!storeTalg) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006239'));
          return false;
        }
        // 状态是待执行发货的才能执行发货
        let executeDespatchTalg = v.selectTableData.every((item) => {
          return item.executeDespatchStatus === 2
        });
        if (!executeDespatchTalg) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006240'));
          return false;
        }
        // 对于货品订单，手工订单和平台订单不可同时执行发货
        let goodsTalg = v.selectTableData.every((item) => {
          return item.orderType === 'TEMU_P'
        });
        let sampleTalg = v.selectTableData.every((item) => {
          return item.orderType === 'TEMU_S'
        });
        if (sampleTalg) {
          // 样品订单无需上传打包标签,走新版本的执行发货流程
          v.$refs['sampleOrder'].initSampleOrder(v.selectTableData);
        } else {
          if (goodsTalg) {
            let talg_1 = v.selectTableData.every((item) => {
              return item.isHand === 2
            });
            let talg_0 = v.selectTableData.every((item) => {
              return item.isHand === 0
            });
            if (talg_1 || talg_0) {
              // 手工单--货品订单 还是走第一版的执行发货流程
              if (talg_1) {
                v.$refs['temuExecuteShipment'].initTemuExecuteShipmentData(v.selectTableData);
              }
              // 平台单-货品订单
              if (talg_0) {
                v.$Modal.confirm({
                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006241'),
                  content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006179')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006180')}`,
                  okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006241'),
                  cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
                  onOk: () => {
                    let query = {
                      deliveryGroup: '',
                      deliveryName: '',
                      platformOrderImplementShipmentsBos: v.selectTableData.map((item) => {
                        return {ymsPlatformOrderId: item.ymsPlatformOrderId}
                      }),
                      trackingNumber: null,
                      ymsLogisServiceId: null
                    }
                    v.axios.put(api.put_ymsPlatformOrder_implementShipment, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}).then(response => {
                      if (response.data.code === 0) {
                        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006242'));
                        v.pageParamsStatus = true;
                      }
                    });
                  },
                  onCancel: () => {
                  }
                });
              }
            } else {
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006243'));
              return false;
            }
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006244'));
            return false;
          }
        }
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006245'));
        return false;
      }
    },
    // 切换Tab
    changeTab(value) {
      let v = this;
      if (['null', '1'].includes(value)) {
        v.showNumericalValue = true;
      } else {
        v.showNumericalValue = false;
      }
      v.orderTabTypeList.map((item) => {
        item.disabled = true;
      });
      v.$nextTick(() => {
        v.$refs['pageParams'].resetFields();
        v.payTime = [];
        v.resetDate();
        v.selectTableData = [];
        v.pendingData = [];
        if (['null', '5', '6'].includes(v.pageParams.orderTabStatus)) {
          v.setDefaultTimerParams('three_months');
        }
        v.getProductsNum(true);
        v.pageParams.pageNum = 1;
        this.pageParams.pageNum = 1;
        v.pageParamsStatus = true;
        v.$forceUpdate();
      });
    },
    // 标记非Yms订单
    markNonYmsOrdersBtn(type, ymsPlatformOrderId) {
      let v = this;
      let ymsPlatformOrderIds = [];
      if (type === 'all') {
        if (v.selectTableData.length > 0) {
          ymsPlatformOrderIds = v.selectTableData.map((item) => {
            return item.ymsPlatformOrderId
          });
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005504'));
          return false;
        }
      } else {
        ymsPlatformOrderIds = [ymsPlatformOrderId];
      }
      let query = {
        isYmsOrder: 1, // 是否YMS订单{1：否 2：是}
        ymsPlatformOrderIds: ymsPlatformOrderIds
      }
      v.axios.post(api.post_ymsPlatformOrder_isYmsOrderUpdate, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.selectTableData = [];
          v.$refs['selection'].selectAll(false);
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          v.getProductsNum();
          v.search();
        }
      });
    },
    // 处理订单
    processOrderBtn(ymsPlatformOrderId) {
      let v = this;
      v.axios.get(api.get_ymsPlatformOrder_matchingGoods + ymsPlatformOrderId).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          v.pageParamsStatus = true;
        }
      });
    },
    // 获取待处理的商品数
    getProductsNum(value) {
      let v = this;
      v.pendingData = [];
      v.showTab = value || false;
      return new Promise((resolve) => {
        if (['null', '1'].includes(v.pageParams.orderTabStatus)) {
          v.axios.get(api.get_ymsPlatformOrder_queryTotal + '?orderTabStatus=1').then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas || [];
              v.pendingTalg = true;
              resolve(true);
              if (data.length > 0) {
                v.reviewedTotal = data.reduce((pre, cur) => pre + cur.orderCount, 0);
                v.pendingData = data;
                v.showTab = true;
                v.orderTabTypeList.map((item) => {
                  item.disabled = false;
                });
                v.$forceUpdate();
              } else {
                v.showTab = true;
                v.orderTabTypeList.map((item) => {
                  item.disabled = false;
                });
              }
            } else {
              v.showTab = true;
              v.reviewedTotal = 0;
              v.orderTabTypeList.map((item) => {
                item.disabled = false;
              });
            }
          });
        } else {
          v.orderTabTypeList.map((item) => {
            item.disabled = false;
          });
        }
      });
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn() {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsPlatformOrderIds = v.selectTableData.map((item) => {
          return item.ymsPlatformOrderId
        });
      } else {
        query.ymsPlatformOrderIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          v.axios.post(api.post_ymsPlatformOrder_excelYmsPlatformOrderExport, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/distributor.html#/exportTask?operateCode=' + taskNumber, '/yms-distributor-service', '_blank');
              }, 30)
            }
          });
        }
      });
    },
    // 更新数据
    updateData() {
      this.getProductsNum();
      this.pageParamsStatus = true;
    },
    // 获取当前列表设置展示的字段
    customColumnsData(data) {
      this.setColumnsList = data;
      this.handleColumns(data);
    },
    // 确认等待
    confirmWaitingBtn(ymsPlatformOrderId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006246'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006247'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006204'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.put(api.put_ymsPlatformOrder_waitingForConfirmation, {ymsPlatformOrderId}, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 判断是否可以操作取消订单
    cancelOrderTalg(data) {
      /*
      1.当平台=eBay，产生YMS订单前（待匹配商品、待匹配物流、下单失败），展示取消订单按钮。弹窗内仅支持取消平台订单。
      2.除1所含平台，产生YMS订单前（待匹配商品、待匹配物流、下单失败），不展示取消订单按钮。
      3.当平台=eBay，产生YMS订单后，当YMS订单状态为已装箱前时，展示取消订单按钮，弹窗内可支持取消平台订单及YMS订单。
      4.除1所含平台，产生YMS订单后，当YMS订单状态为已装箱前时，展示取消订单按钮，弹窗内仅可取消YMS订单。
      5.平台订单没有作废或YMS订单部分取消，展示取消按钮
      6. allowInvalid: 1 允许标记取消   0不允许标记取消
    */
      if (data) {
        let talg = false;
        let ymsPackageInfoTalg = false;
        let newList = [];
        let ymsPlatformOrderPackageRelateds = data.ymsPlatformOrderPackageRelateds || [];
        if (ymsPlatformOrderPackageRelateds.length > 0) {
          // 过滤掉已经取消的YMS订单
          newList = ymsPlatformOrderPackageRelateds.filter((ele) => {
            return ele.ymsPackageInfo && ele.ymsPackageInfo.status !== 8
          });
          ymsPackageInfoTalg = newList.length > 0;
        }
        let type = data.isInvalid !== 1 || data.invalidType === 1; // 平台订单没有作废或YMS订单部分取消
        if (type) {
          // 没有生成YMS订单（平台订单允许整单取消）
          if (!ymsPackageInfoTalg) {
            if (['ebay', 'aliexpress', 'fruugo', 'ozon', 'shopee', 'walmart', 'wish'].includes(data.platformId)) {
              talg = true;
            }
          }
          // 生成YMS订单
          else {
            talg = newList.every(i => i.ymsPackageInfo && i.ymsPackageInfo.status < 6); // 已装箱之前
          }
        }
        // 判断当前平台订单中是否有允许标记取消YMS订单
        let invalidConfirmTalg = newList.some((item) => {
          return item.ymsPackageInfo.allowInvalid === 1 && item.ymsPackageInfo.status === 6;
        });
        if (invalidConfirmTalg) {
          talg = true;
        }
        return talg;
      }
    },
    // 取消订单
    cancelOrderBtn(data) {
      let v = this;
      if (data) {
        let ymsPackageInfoTalg = false;
        let ymsPlatformOrderPackageRelateds = data.ymsPlatformOrderPackageRelateds || [];
        if (ymsPlatformOrderPackageRelateds.length > 0) {
          let newList = ymsPlatformOrderPackageRelateds.filter((ele) => {
            return ele.ymsPackageInfo && ele.ymsPackageInfo.status !== 8
          });
          ymsPackageInfoTalg = newList.length > 0;
        }
        v.axios.get(api.get_ymsPlatformOrder + data.ymsPlatformOrderId, {loading: true}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.$refs['cancelPlatformOrder'].initCancelOrderData(data, data.ymsPlatformOrderId, ymsPackageInfoTalg, 'platformOrder');
            }
          }
        })
      }
    },
    // 判断是否可以操作手动标记
    manualMarkingTalg(data) {
      let talg = false;
      let newList = [];
      let ymsPackageInfoTalg = false;
      let ymsPlatformOrderPackageRelateds = data.ymsPlatformOrderPackageRelateds || [];
      if (ymsPlatformOrderPackageRelateds.length > 0) {
        newList = ymsPlatformOrderPackageRelateds.filter((ele) => {
          return ele.ymsPackageInfo
        });
        ymsPackageInfoTalg = newList.length > 0;
      }
      // 是YMS订单、生成YMS订单、不是Temu平台、不是速卖通全托管类型订单，标发货失败，的可以操作手动标记
      if (data.isYmsOrder === 2 && data.platformId !== 'temu' && ymsPackageInfoTalg && data.orderType !== 'ONE_STOP_SERVICE' &&
        this.getPermission('ymsPlatformOrder_handMarkedShipmentSuccess') && !data.despatchedTime && data.abnormalStatus === 4) {
        talg = true;
      }
      return talg;
    },
    // 手动标记
    manualMarkingBtn(ymsPlatformOrderId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006248'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006249'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006250'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.put(api.put_ymsPlatformOrder_handMarkedShipmentSuccess + ymsPlatformOrderId, null,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000530'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 单个、批量接单
    receivingOrdersBtn(type, ymsPlatformOrderId) {
      let v = this;
      v.abnormalTitle = '';
      v.orderPromptList = [];
      v.orderPromptModal = false;
      let ymsPlatformOrderIds = [];
      if (type === 'all') {
        if (v.selectTableData.length > 0) {
          let talg = v.selectTableData.every((ele) => {
            return ele.abnormalStatus === 0 // 待接单
          });
          if (talg) {
            ymsPlatformOrderIds = v.selectTableData.map((item) => {
              return item.ymsPlatformOrderId
            })
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006251'));
            return false;
          }
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006252'));
          return false;
        }
      } else {
        ymsPlatformOrderIds = [ymsPlatformOrderId];
      }
      if (ymsPlatformOrderIds.length > 0) {
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006253'),
          content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006181')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006182')}
          ${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006183')}`,
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006253'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            v.axios.post(api.post_ymsPlatformOrder_orderConfirmation, ymsPlatformOrderIds,
              {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                let data = response.data.datas || [];
                let talg = data.every((item) => {
                  return item.success === true
                });
                if (talg) {
                  v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006254'));
                } else {
                  let newList = data.filter((item) => {
                    return item.success === false;
                  });
                  v.orderPromptList = newList.map((item) => {
                    return {
                      orderNumber: item.platformOrderId,
                      errorMsg: item.message
                    }
                  });
                  v.abnormalTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006255');
                  v.orderPromptModal = true;
                }
                v.getProductsNum();
                v.pageParamsStatus = true;
              }
            });
          },
          onCancel: () => {
          }
        });
      }
    },
    // 根据不同的获取不同的平台订单类型
    handleOrderTypeData(platformId) {
      this.orderTypesList = [];
      if (this.orderTypePlatformIds.includes(platformId)) {
        const orderTypes = {
          // Temu平台
          temu: [
            {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'), value: 3},
            {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006256'), value: 1},
            {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006257'), value: 2}
          ],
          // 速卖通全托管平台
          aliexpress: [
            {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'), value: 6},
            {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006258'), value: 4},
            {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006259'), value: 5}
          ]
        };
        this.orderTypesList = orderTypes[platformId];
        this.pageParams.orderTypeTag = orderTypes[platformId][0].value;
      }
    },
    /**
     * 注册平台订单待办变化使用的 websocket 监听。
     */
    initWebSocket() {
      let v = this;
      if (!v.$webSocket.initWebSocket()) {
        return;
      }
      v.webSocketListenerKey = `platform-order-${v._uid}`;
      v.$webSocket.subscribeMessage(v.webSocketListenerKey, (e) => {
        const data = v.$webSocket.parseMessage(e);
        if (data && data.type === 'pending') {
          v.getProductsNum(true);
        }
      }, v);
    },

    /**
     * 清理平台订单待办变化监听。
     */
    clearWebSocketListener() {
      if (!this.webSocketListenerKey) return;
      this.$webSocket.unsubscribeMessage(this.webSocketListenerKey);
      this.webSocketListenerKey = '';
    },
    // 忽略
    ignoreBtn(ymsPlatformOrderId) {
      let v = this;
      v.axios.put(api.put_ymsPlatformOrder_handModiftAddress + ymsPlatformOrderId, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
        if (res.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
          v.updateData();
        }
      });
    },
    // 标记已处理
    markProcessedBtn(ymsPlatformOrderId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006012'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006260'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006012'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.put(api.put_ymsPlatformOrder_markDealed + ymsPlatformOrderId, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
              v.updateData();
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      if (this.$refs.dropDownFilter) {
        this.$refs.dropDownFilter.inputValue = '';
      }
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // yms订单付款
    ymsPaymentBtn(ymsPlatformOrderId, row) {
      // 校验余额
      let ymsPlatformOrderPackageRelateds = row.ymsPlatformOrderPackageRelateds || [];
      let list = ymsPlatformOrderPackageRelateds.filter((item) => {
        return item.ymsPackageInfo?.status !== 8 &&
          item.ymsPackageInfo?.payStatus !== 2 &&
          ![1, 2].includes(item.ymsPackageInfo?.offlinePaymentStatus)
      });
      const totalPrice = list.reduce((sum, item) => {
        return sum + (item.ymsPackageInfo.totalPrice || 0);
      }, 0);
      let obj = {
        currency: this.currencyState,
        totalPrice: Number(totalPrice),
        params: {
          url: api.post_ymsPlatformOrder_platformOrderPayment,
          query: {
            ymsPlatformOrderId,
            totalAmount: Number(totalPrice)
          }
        },
      }
      this.$refs['orderSubmission'].initOrderSubmissionData(obj, true)
    },
    // 倒计时
    handleCountDown(ymsPackageId) {
      const v = this;
      if (!v.countdowns[ymsPackageId]) {
        v.$set(v.countdowns, ymsPackageId, {timer: null, leftTime: ''});
      }
      // 如果已有倒计时，清除
      if (v.countdowns[ymsPackageId].timer) {
        clearInterval(v.countdowns[ymsPackageId].timer);
      }
      let time = v.$uDate.dealTime(v.countdownsTime[ymsPackageId].payLeftTime, 'fulltime');
      const endTime = new Date(time).getTime();
      v.countdowns[ymsPackageId].timer = setInterval(() => {
        const now = Date.now();
        const remainingSeconds = Math.max(0, Math.floor((endTime - now) / 1000));
        const formattedTime = v.$uDate.formatTime(remainingSeconds);
        let value = remainingSeconds > 0 ? formattedTime : 0;
        v.$set(v.countdowns[ymsPackageId], 'leftTime', value);
        if (remainingSeconds <= 0) {
          clearInterval(v.countdowns[ymsPackageId].timer);
        }
      }, 1000);
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
    // 监听平台
    'pageParams.platformId': {
      handler(value) {
        this.handleOrderTypeData(value);
      },
      deep: true,
      immediate: true
    }
  },
  beforeDestroy() {
    EventBus.$off('updatePlatformOrder');
    this._isDestroyed = true;
  },
};
</script>

<style lang="less">
.platform-order {
  .operate-history {
    color: #333333;
    font-size: 18px;
    cursor: pointer;
  }

  .operate-history:hover {
    color: #000;
  }

  .order-cancel {
    color: #ee3131;
    font-size: 18px;
  }

  .match-product, .match-logistics, .match-place-order, .match-mark-goods {
    cursor: pointer;
    opacity: 0.9;
    margin-right: 3px;
  }

  .match-product:hover, .match-logistics:hover, .match-place-order:hover, .match-mark-goods:hover {
    cursor: pointer;
    opacity: 1;
  }

  .match-product {
    color: #b96e45;
  }

  .match-logistics {
    color: #7bb945;
  }

  .match-place-order {
    color: #45b95e;
  }

  .match-mark-goods {
    color: #4579b9;
  }

  .order-number {
    color: #2f73a3;
    cursor: pointer;
  }

  .order-number:hover {
    text-decoration: underline;
  }
}
</style>

<style lang="less" scoped>

/*列表固定列的调整样式---> 通过position: sticky; 样式控制固定列的位置*/
/deep/ .table-box {
  td.options_styles_box {
    position: sticky !important;
    right: 0px;
    z-index: 5;
    overflow: initial !important;

    &:before {
      left: -2px;
      top: 0;
      content: ' ';
      width: 2px;
      height: 100%;
      background: #e8eaec;
      position: absolute;
      z-index: 100;
    }

    &:after {
      right: -1px;
      top: 0;
      content: ' ';
      width: 2px;
      height: 100%;
      background: #fff;
      position: absolute;
      z-index: 100;
    }
  }

  th.options_styles_box {
    position: sticky !important;
    right: 0px;
    z-index: 5;
    overflow: initial !important;

    &:before {
      left: -2px;
      top: 0;
      content: ' ';
      width: 2px;
      height: 100%;
      background: #e8eaec;
      position: absolute;
      z-index: 100;
    }
  }

  th.options_styles_box:nth-last-child(2) {
    position: sticky !important;
    right: 12px;
    z-index: 5;
    overflow: initial !important;

    &:before {
      left: -2px;
      top: 0;
      content: ' ';
      width: 2px;
      height: 100%;
      background: #e8eaec;
      position: absolute;
      z-index: 100;
    }

    &:after {
      right: -12px;
      top: 0;
      content: ' ';
      width: 14px;
      height: 100%;
      background: #F8F8F9;
      position: absolute;
      z-index: 100;
    }
  }

  .platformOrderInfo_styles_box {
    position: sticky !important;
    left: 60px;
    z-index: 5;
    overflow: initial !important;

    &:after {
      right: -2px;
      top: 0;
      content: ' ';
      width: 2px;
      height: 100%;
      background: #e8eaec;
      position: absolute;
      z-index: 100;
    }
  }

  .selection_styles_box {
    position: sticky !important;
    left: 0;
    z-index: 5;
    overflow: initial !important;

    &:after {
      right: -2px;
      top: 0;
      content: ' ';
      width: 2px;
      height: 100%;
      background: #e8eaec;
      position: absolute;
      z-index: 100;
    }
  }

  .alibabaOrders_item {
    display: inline-block;
    margin: 6px 0 0 0;
    border-radius: 4px;
    overflow: hidden;
    font-size: 12px;
    padding: 3px 5px;
    color: #FD5425;
    border: 1px solid #FD5425;
  }
}

.red {
  color: red;
}

/deep/ .tips_style {
  .ivu-modal-body {
    max-height: 500px;
    overflow-y: auto;
  }

  .tips_center {
    display: flex;
    align-items: center;
    margin: 8px 0;

    .title {
      color: #FD5425;
      font-weight: bold;
      margin-right: 5px;
    }

    .txt {
      color: #333;
    }
  }
}

.table-box /deep/ .ivu-table .ivu-table-tbody {
  .ymsPackageGoodBox {
    width: 70px;
    height: 70px;
    position: relative;
    border: 1px solid #EBEBEB;
    box-sizing: border-box;
    border-radius: 4px;
    overflow: hidden;
    margin: 2px 5px;
    cursor: pointer;

    .ymsPackageGoodImg {
      width: 100%;
      height: auto;
      objectFit: cover;
      verticalAlign: middle;
    }

    .ymsPackageGoodQuantity {
      padding: 2px 3px;
      border-radius: 4px;
      background-color: #fff;
      color: #000;
      font-size: 12px;
      line-height: 12px;
      text-align: center;
      position: absolute;
      bottom: 5px;
      right: 5px;
    }

    .maskBox {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
    }
  }

  .TiktokCBT_box {
    display: inline-block;
    padding: 0px 8px;
    border-radius: 15px;
    color: #FD5425;
    border: 1px solid #FD5425;
    margin-right: 5px;
    font-size: 12px;
  }
}
</style>
